<script setup lang="ts">
import { computed, watch } from 'vue';
import type { Question, QuestionStatus } from '@/types/TestReview';
import useQuestionPagination from '@/composables/useQuestionPagination';
import TestReviewStatusIcon from '@/components/Student/TestReview/TestReviewStatusIcon.vue';
import { getPrimaryQuestionStatus } from '@/functions/testReviewHelpers';

const props = defineProps<{
    questions: Question[],
}>();

const pagination = useQuestionPagination();
const selected = computed(() => pagination.value.page);

watch(() => props.questions, () => {
    pagination.value = useQuestionPagination().value;
});

</script>

<template>
    <q-list
        dense
        separator
        role="list"
    >
        <q-item
            v-for="(question, index) in questions"
            :key="question.number"
            class="question-list-item"
            :clickable="!question.visible"
            @click="pagination.set(index + 1)"
        >
            <q-item-section
                side
                top
            >
                <q-radio
                    v-model="selected"
                    :val="index + 1"
                    color="primary"
                    :aria-label="'Select question ' + (index + 1)"
                    @click="pagination.set(index + 1)"
                />
            </q-item-section>
            <q-item-section class="question-number">
                Question {{ question.number }}
            </q-item-section>
            <q-item-section no-wrap>
                <div class="row justify-start">
                    <TestReviewStatusIcon
                        :label="getPrimaryQuestionStatus(question)"
                        :class="'col-fit q-pr-sm'"
                    />
                    <TestReviewStatusIcon
                        v-if="question.marked"
                        :label="('flagged' as QuestionStatus)"
                        :class="'col-fit'"
                    />
                </div>
            </q-item-section>
        </q-item>
    </q-list>
    <div
        v-if="questions.length === 0"
        class="column items-center q-py-lg"
    >
        <q-icon
            name="sym_o_error"
            size="50px"
        />
        <span class="text-h6">No results found</span>
    </div>
</template>

<style scoped lang="scss">
.question-number {
    font-size: 14px;
}
</style>
